import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ToastService } from '../../services/toast.service';
import { Icon } from '../icon/icon';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [Icon, RouterLink],
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
})
export class Toast {
  toastService = inject(ToastService);
}
